var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tagNames.length > 0 && _vm.tagNames[0] !== null)?_c('v-chip-group',{attrs:{"column":""}},_vm._l((_vm.tagsWithPrimaryFirst),function(tag){return _c('v-chip',{key:tag,attrs:{"ripple":false,"outlined":tag!==_vm.primaryTagName}},[_vm._v(_vm._s(tag))])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }